/// <reference path="../../../typings/tsd.d.ts" /> 

module warsApp.directives {
    export interface IProcessEventSectionScope extends ng.IScope {
        model: ProcessEventSectionModel;
        isConfigureMode: boolean;
        isEditMode: boolean;
        process: Wars.Domain.Model.Dtos.ProcessDto;
        processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        processConfigurationId: string;
        manageSection: Wars.Domain.Model.ManageSection;
        documentUpdated(model: models.FileUploadModel): void;
    }

    export class ProcessEventSection implements IDirective {
        public link($scope: IFieldSectionScope,
            element: JQuery,
            attrs: ng.IAttributes) {
        }

        public templateUrl = './app/views/directives/manageForm/processEventSection.html';
        public controller = ['$scope', 'formService', 'processEventConfigurationService', 'systemLevelService', 'processService', 'processDocumentService', 'ModalService', ProcessEventSectionController];
        public controllerAs = 'controller';
        public restrict: string = 'E';
        public scope: any = {
            isConfigureMode: "=",
            isEditMode: "=",
            process: "=",
            processConfiguration: "=",
            processConfigurationId: "=",
            manageSection: "="
        };
    }

    export class ProcessEventSectionModel {

        public processEventConfigurations: Wars.Domain.Model.ProcessEventConfiguration[];
        public selectableProcessEventConfigurations: any[];
        public addingEvent = false;
        public newProcessEventDto: models.ProcessEventDto;
        public newResponseDocIds: string[];
        public documentConfiguration: Wars.Domain.Model.Documents.DocumentConfiguration;
        public processEventConfiguration: Wars.Domain.Model.ProcessEventConfiguration;

        constructor(
            private formService: services.FormService,
            private processEventConfigurationService: services.ProcessEventConfigurationService,
            private systemLevelService: services.SystemLevelService,
            private processService: services.ProcessService,
            private processDocumentService: services.ProcessDocumentService,
            private modalService: any,
            private processConfigurationId,
            public isConfigureMode: boolean,
            public manageSection: Wars.Domain.Model.ManageSection,
            private process: Wars.Domain.Model.Dtos.ProcessDto,
            private processConfiguration: Wars.Domain.Model.ProcessConfiguration) {

            if (isConfigureMode) {
                this.selectableProcessEventConfigurations = [];
                this.systemLevelService.getSystemLevelProcessEvents().then(
                    (systemLevel) => {
                        systemLevel.myProcessEventConfigurations.forEach(spc => {
                            var reso = Enumerable.from(manageSection.manageProcessEventConfiguration.manageProcessEventConfigResos).firstOrDefault(i => i.processEventConfiguration_id === spc.id);

                            var selectableProcessEventConfiguration = {
                                id: spc.id,
                                resoId: reso ? reso.id : "",
                                uniqueIdentifier: spc.uniqueIdentifier,
                                name: spc.name,
                                buttonOrder: reso ? reso.buttonOrder : "",
                                isSytemLevel: true,
                                isSelected: reso ? true : false
                            };
                            this.selectableProcessEventConfigurations.push(selectableProcessEventConfiguration);
                        });
                        this.orderByName();
                        processEventConfigurationService.getProcessEventConfigurations(processConfigurationId)
                            .then(processConfigs => {
                                this.processEventConfigurations = processConfigs;
                                processConfigs.forEach(pc => {
                                    var reso = Enumerable.from(manageSection.manageProcessEventConfiguration.manageProcessEventConfigResos).firstOrDefault(i => i.processEventConfiguration_id === pc.id);

                                    var selectableProcessEventConfiguration = {
                                        id: pc.id,
                                        resoId: reso ? reso.id : "",
                                        uniqueIdentifier: pc.uniqueIdentifier,
                                        name: pc.name,
                                        buttonOrder: reso ? reso.buttonOrder : "",
                                        processTypeName: pc.myProcessConfiguration.myProcessType.name,
                                        isSytemLevel: false,
                                        isSelected: reso ? true : false
                                    };
                                    this.selectableProcessEventConfigurations.push(selectableProcessEventConfiguration);
                                });
                                this.orderByName();
                            });
                    });
            } else {
            }
        }

        private orderByName() {
            if (this.selectableProcessEventConfigurations && this.selectableProcessEventConfigurations.length > 0) {
                var maxOrder = this.getMaxOrder();
                var specWithoutOrder = Enumerable.from(this.selectableProcessEventConfigurations).where(i => i.isSelected === false).orderBy(ii => ii.name);
                specWithoutOrder.forEach((spec) => {
                    maxOrder += 1;
                    spec.buttonOrder = maxOrder;
                });
            }
        }

        private getMaxOrder() {
            var maxOrder = Enumerable.from(this.selectableProcessEventConfigurations).max(i => i.buttonOrder);
            if (maxOrder.toString() === "") {
                maxOrder = 0;
            } else {
                maxOrder += 1;
            }
            return maxOrder;
        }

        private processEventConfigurationChanged(selectableProcessEventConfiguration: any) {
            this.selectableProcessEventConfigurations.forEach((spec) => {
                if (!spec.isSelected) {
                    spec.buttonOrder = "";
                }
            });
            if (selectableProcessEventConfiguration.isSelected) {
                var processEventConfigurationReso = this.processEventConfigurationService.createProcessEventConfigurationReso();
                processEventConfigurationReso.manageProcessEventConfiguration_id = this.manageSection.manageProcessEventConfiguration.id;
                processEventConfigurationReso.processEventConfiguration_id = selectableProcessEventConfiguration.id;
                selectableProcessEventConfiguration.resoId = processEventConfigurationReso.id;
                selectableProcessEventConfiguration.buttonOrder = "";
                processEventConfigurationReso.buttonOrder = this.getMaxOrder();
                selectableProcessEventConfiguration.buttonOrder = processEventConfigurationReso.buttonOrder;
            } else {
                var processEventReso = Enumerable.from(this.manageSection.manageProcessEventConfiguration.manageProcessEventConfigResos).first(i => i.processEventConfiguration_id === selectableProcessEventConfiguration.id);
                processEventReso.entityAspect.setDeleted();
            }
            this.formService.saveAllChanges(() => {
                this.orderByName();
            });
        }
        
        private processEventClicked(processEventAction: Wars.Domain.Model.Dtos.ProcessEventActionDto) {
            
            var processEventConfiguration = Enumerable.from(this.manageSection.manageProcessEventConfiguration.manageProcessEventConfigResos)
                .where(i => i.processEventConfiguration != null)
                .first(i => i.processEventConfiguration.uniqueIdentifier === processEventAction.processEventConfigUniqueId).processEventConfiguration;

            this.newProcessEventDto = new models.ProcessEventDto();
            this.newProcessEventDto.NotificationType = processEventConfiguration.name;
            this.newProcessEventDto.Comment = "";
            this.newResponseDocIds = [];
            this.documentConfiguration = processEventConfiguration.documentConfiguration;
            this.processEventConfiguration = processEventConfiguration;
            if (this.processEventConfiguration.allowAttachments || this.processEventConfiguration.allowComment) {
                this.addingEvent = true;
            } else {
                this.saveEvent();
            }
        }

        private saveEvent() {
            this.newProcessEventDto.ProcessEventConfigUniqueId = this.processEventConfiguration.uniqueIdentifier;
            this.newProcessEventDto.DocumentIds = this.newResponseDocIds;
            this.processService.addProcessEvent(this.process.id, this.newProcessEventDto).then((processEventDto) => {
                this.addingEvent = false;
                this.process.processEvents.push(processEventDto);
            });
        }

        private cancelEvent() {
            this.addingEvent = false;
        }

        public documentUpdated(model: models.FileUploadModel): void {
            this.newResponseDocIds = Enumerable.from(model.documents).select(i => i.id).toArray();
        }

        private openDocumentModal(processEventDto: Wars.Domain.Model.Dtos.ProcessEventDto) {
            var documentForModal = [];
            for (var i = 0; i < processEventDto.documentIds.length; i++) {
                var document = this.processDocumentService.getDocumentById(this.process, processEventDto.documentIds[i]);
                if (document) {
                    documentForModal.push(document);
                }
            }
            this.modalService.showModal({
                templateUrl: "./app/views/modals/repeatingDocumentViewModal.html",
                controller: "repeatingDocumentViewModalController",
                inputs: {
                    documents: documentForModal,
                    process: this.process
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                });
            });
        }

        public sortProcessEventConfigurations($item: any, $partFrom: any[], $partTo, $indexFrom, $indexTo, $modal) {
            var arrayCopy = Enumerable.from($partFrom).orderBy(z => z.buttonOrder).toArray();

            var spliced = arrayCopy.splice($indexFrom, 1);
            arrayCopy.splice($indexTo, 0, spliced[0]);

            $item.buttonOrder = $indexTo;

            for (var i = 0; i < $partFrom.length; i++) {
                var numberId = $partFrom[i].id;
                $partFrom[i].buttonOrder = Enumerable.from(arrayCopy).indexOf(i => i.id == numberId);
            }

            this.manageSection.manageProcessEventConfiguration.manageProcessEventConfigResos.forEach((reso) => {
                var spec = Enumerable.from($partFrom).firstOrDefault(i => i.resoId === reso.id);
                if (spec) {
                    reso.buttonOrder = spec.buttonOrder;
                }
            });
            this.formService.saveAllChanges();
        }
    }

    export class ProcessEventSectionController {

        constructor(
            private scope: IProcessEventSectionScope,
            private formService: services.FormService,
            private processEventConfigurationService: services.ProcessEventConfigurationService,
            private systemLevelService: services.SystemLevelService,
            private processService: services.ProcessService,
            private processDocumentService: services.ProcessDocumentService,
            private modalService: any)
        {
            this.initialize();

            if (!scope.isConfigureMode) {
                scope.$watch("process",
                    (newValue) => {
                        if (newValue !== undefined && newValue !== null) {
                            this.initialize();
                        } else {
                            scope.model = undefined;
                        }
                    });
            }
        }

        private initialize() {
            this.scope.model = new ProcessEventSectionModel(
                this.formService,
                this.processEventConfigurationService,
                this.systemLevelService,
                this.processService,
                this.processDocumentService,
                this.modalService,
                this.scope.processConfigurationId,
                this.scope.isConfigureMode,
                this.scope.manageSection,
                this.scope.process,
                this.scope.processConfiguration);

            this.scope.documentUpdated = (model: models.FileUploadModel) => this.scope.model.documentUpdated(model);
        }
    }
}
warsApp.registerDirective('ProcessEventSection', []);